import { CSSProperties } from 'react';

interface IStyles {
  wrapper: (borderRadius: number) => CSSProperties;
}

export const styles: IStyles = {
  wrapper: (borderRadius) => ({
    border: 0,
    borderRadius,
  }),
};
